var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gatilhos-page"},[_c('AcaoObjetoList',{attrs:{"endpoint-base":"/admin/gatilhos","modal-name":"gatilhoEdit","entidades-excluir":['sac']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }